module.exports = __webpack_public_path__ + "img/example.185a7aaa.png";